import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/auth/index'
import dataEntities from "@/store/dataEntities";
import snackbar from "@/store/snackbar";
import customRequests from "@/store/custom-requests";
import settings from '@/store/settings';
import tour from '@/store/tour'
import tabs from '@/store/tabs'
Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    dataEntities,
    snackbar,
    customRequests,
    settings,
    tour,
    tabs
  },
})

export default store